/**
 * ZenMarkup Privacy Analytics — UI module.
 *
 * DOM helpers and loading states.
 */

import { init as initDatePicker } from './datepicker.js';
import { fetchExport } from './api-export.js';
import { redraw as lineChartRedraw } from './line-chart.js';

let firstLoad = true;

/**
 * First load: show full-page spinner, hide content.
 * Subsequent loads: overlay spinner on top of existing content.
 */
export function showLoading() {
	const loading = document.querySelector('[data-el="loading"]');
	const content = document.querySelector('[data-el="content"]');

	if (firstLoad) {
		if (loading) {
			loading.style.display = '';
		}
		if (content) {
			content.style.display = 'none';
		}
		return;
	}

	if (content) {
		content.classList.add('zmpa-updating');
	}
}

/**
 * Hide loading state and show content.
 */
export function showContent() {
	const loading = document.querySelector('[data-el="loading"]');
	const content = document.querySelector('[data-el="content"]');

	if (loading) {
		loading.style.display = 'none';
	}
	if (content) {
		content.style.display = 'block';
		content.classList.remove('zmpa-updating');
	}

	firstLoad = false;
}

/**
 * Initialize CSV export button.
 */
function initExportButton() {
	const btn = document.querySelector('[data-el="export-btn"]');
	if (!btn) {
		return;
	}

	btn.addEventListener('click', function () {
		const activeTab = document.querySelector('[data-el="tab"].zmpa-tab-active');
		if (!activeTab) {
			return;
		}
		const tab = activeTab.getAttribute('data-tab');
		if (tab) {
			fetchExport(tab);
		}
	});
}

/**
 * Initialize tab navigation.
 */
function initTabs() {
	const tabs = document.querySelectorAll('[data-el="tab"]');
	const panels = document.querySelectorAll('[data-el="tab-panel"]');

	tabs.forEach(function (tab) {
		tab.addEventListener('click', function () {
			const target = tab.getAttribute('data-tab');

			tabs.forEach(function (t) {
				t.classList.remove('zmpa-tab-active');
			});
			tab.classList.add('zmpa-tab-active');

			panels.forEach(function (panel) {
				if (panel.getAttribute('data-tab') === target) {
					panel.style.display = '';
					panel.classList.add('zmpa-tab-panel-active');
				} else {
					panel.style.display = 'none';
					panel.classList.remove('zmpa-tab-panel-active');
				}
			});

			/* Redraw canvas charts when switching to Overview (hidden tabs have 0 width). */
			if (target === 'overview') {
				setTimeout(lineChartRedraw, 0);
			}
		});
	});
}

/**
 * Initialize the UI: render date picker and tabs.
 */
export function init() {
	initDatePicker();
	initTabs();
	initExportButton();
}
